import { IPdfContent } from "@domains/aggregates/interfaces/iFooterPages";
import React from "react";
import { Row, Col } from "react-bootstrap";
import DeviceContext from "@/components/generic/customHooks/indentifyDevice";

interface IPdfCard {
  pdfList: Array<IPdfContent>;
}
const PdfCard = (props: IPdfCard) => {
  const device = DeviceContext();
  function openNewTab(link: string) {
    window.open(link, "_blank");
  }
  return (
    <>
      {props.pdfList.map((pdf: IPdfContent, idx) => {
        return (
          <Row
            key={idx}
            className={`hand_cursor  m-0 ${
              device?.isDesktop ? "DMSans_16_500" : "DMSanN_14_400"
            }`}
            onClick={() => openNewTab(pdf.link)}
          >
            <Col xs={10} className="txt_blackOne1">
              {pdf.pdfName}
            </Col>
            <Col xs={2} className="d-flex justify-content-end">
              <i className="edel-icon-pdf txt-midnight-blue"></i>
            </Col>
          </Row>
        );
      })}
    </>
  );
};

export default PdfCard;
